module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "topBar"
  }, [_c('div', {
    staticClass: "topBar--item_left"
  }, [_c('div', {
    staticClass: "input_text"
  }, [_c('v-select', {
    attrs: {
      "searchable": false,
      "placeholder": "Click to select a wall",
      "options": _vm.walls
    },
    model: {
      value: (_vm.wallId),
      callback: function($$v) {
        _vm.wallId = $$v
      },
      expression: "wallId"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn_blue u-mr1",
    on: {
      "click": function($event) {
        _vm.filter()
      }
    }
  }, [_vm._v("\n                Filter\n            ")]), _vm._v(" "), (_vm.query.wallId) ? _c('button', {
    staticClass: "btn btn_blue",
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_vm._v("\n                X\n            ")]) : _vm._e()]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "table--row table--row_header"
  }, [_c('div', {
    staticClass: "table--col",
    class: _vm.getSortClasses('slot'),
    staticStyle: {
      "max-width": "138px"
    },
    on: {
      "click": function($event) {
        _vm.sort('slot')
      }
    }
  }, [_c('div', {
    staticClass: "table--col-title",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                    Timeslot\n                    "), _c('div', {
    staticClass: "table--col-arrows"
  }, [_c('svg', {
    staticClass: "table--col-arrow",
    attrs: {
      "height": "5",
      "viewbox": "0 0 9 5",
      "width": "9",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z",
      "fill-rule": "nonzero"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "table--col-arrow",
    attrs: {
      "height": "5",
      "viewbox": "0 0 9 5",
      "width": "9",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z",
      "fill-rule": "nonzero"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "table--col u-unclickable",
    class: _vm.getSortClasses('wall.name'),
    staticStyle: {
      "max-width": "172px"
    },
    on: {
      "click": function($event) {
        _vm.sort('wall.name')
      }
    }
  }, [_c('div', {
    staticClass: "table--col-title"
  }, [_vm._v("\n                    Wall\n                    "), _c('div', {
    staticClass: "table--col-arrows"
  }, [_c('svg', {
    staticClass: "table--col-arrow",
    attrs: {
      "height": "5",
      "viewbox": "0 0 9 5",
      "width": "9",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z",
      "fill-rule": "nonzero"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "table--col-arrow",
    attrs: {
      "height": "5",
      "viewbox": "0 0 9 5",
      "width": "9",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z",
      "fill-rule": "nonzero"
    }
  })])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "table--col",
    class: _vm.getSortClasses('videoDetails.title'),
    staticStyle: {
      "max-width": "208px"
    },
    on: {
      "click": function($event) {
        _vm.sort('videoDetails.title')
      }
    }
  }, [_c('div', {
    staticClass: "table--col-title"
  }, [_vm._v("\n                    Information\n                    "), _c('div', {
    staticClass: "table--col-arrows"
  }, [_c('svg', {
    staticClass: "table--col-arrow",
    attrs: {
      "height": "5",
      "viewbox": "0 0 9 5",
      "width": "9",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z",
      "fill-rule": "nonzero"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "table--col-arrow",
    attrs: {
      "height": "5",
      "viewbox": "0 0 9 5",
      "width": "9",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z",
      "fill-rule": "nonzero"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "table--col",
    class: _vm.getSortClasses('user.first_name'),
    staticStyle: {
      "max-width": "280px"
    },
    on: {
      "click": function($event) {
        _vm.sort('user.first_name')
      }
    }
  }, [_c('div', {
    staticClass: "table--col-title"
  }, [_vm._v("\n                    User\n                    "), _c('div', {
    staticClass: "table--col-arrows"
  }, [_c('svg', {
    staticClass: "table--col-arrow",
    attrs: {
      "height": "5",
      "viewbox": "0 0 9 5",
      "width": "9",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z",
      "fill-rule": "nonzero"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "table--col-arrow",
    attrs: {
      "height": "5",
      "viewbox": "0 0 9 5",
      "width": "9",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z",
      "fill-rule": "nonzero"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "table--col",
    class: _vm.getSortClasses('status'),
    staticStyle: {
      "max-width": "297px"
    },
    on: {
      "click": function($event) {
        _vm.sort('status')
      }
    }
  }, [_c('div', {
    staticClass: "table--col-row"
  }), _vm._v(" "), _c('div', {
    staticClass: "table--col-title"
  }, [_vm._v("\n                    Status\n                    "), _c('div', {
    staticClass: "table--col-arrows"
  }, [_c('svg', {
    staticClass: "table--col-arrow",
    attrs: {
      "height": "5",
      "viewbox": "0 0 9 5",
      "width": "9",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z",
      "fill-rule": "nonzero"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "table--col-arrow",
    attrs: {
      "height": "5",
      "viewbox": "0 0 9 5",
      "width": "9",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z",
      "fill-rule": "nonzero"
    }
  })])])])])]), _vm._v(" "), _vm._l((_vm.videos), function(video) {
    return _c('div', {
      staticClass: "table--row"
    }, [_c('div', {
      staticClass: "table--col",
      staticStyle: {
        "max-width": "138px"
      }
    }, [_c('strong', [_vm._v("\n                    " + _vm._s(_vm._f("moment")(video.slotDate, "tz", video.wall.city.timezone, "MM/DD/YY")) + "\n                ")]), _vm._v(" "), _c('span', [_vm._v("\n                    " + _vm._s(_vm._f("moment")(video.slotDate, "tz", video.wall.city.timezone, "hh:mma")) + " - " + _vm._s(_vm._f("moment")(video.slotDate, "add", "15 minutes", "tz", video.wall.city.timezone, "hh:mma")) + "\n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "table--col",
      staticStyle: {
        "max-width": "172px"
      }
    }, [_c('strong', [_vm._v("\n                    " + _vm._s(video.wall.name) + "\n                ")]), _vm._v(" "), _c('span', [_vm._v("\n                    " + _vm._s(video.wall.city.name) + "\n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "table--col",
      staticStyle: {
        "max-width": "126px"
      }
    }, [_c('a', {
      staticClass: "table--video",
      style: ({
        'background-image': 'url(' + video.videoDetails.thumbnailUrl + ')'
      }),
      attrs: {
        "href": video.videoDetails.link,
        "target": "_blank"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "table--col",
      staticStyle: {
        "max-width": "208px"
      }
    }, [_c('strong', [_vm._v("\n                    " + _vm._s(video.videoDetails.title) + "\n                ")]), _vm._v(" "), _c('span', [_vm._v("\n                    " + _vm._s(_vm._f("duration")(video.videoDetails.duration)) + "\n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "table--col",
      staticStyle: {
        "max-width": "280px"
      }
    }, [_c('div', {
      staticClass: "table--col-user"
    }, [_c('div', {
      staticClass: "table--col-user-img",
      style: ({
        'background-image': 'url(' + (video.user.picture ? video.user.picture.url : 'http://via.placeholder.com/40x40') + '?api_key=' + _vm.$parent.api_key + ')'
      })
    }), _vm._v(" "), _c('strong', [_vm._v("\n                      " + _vm._s(video.user.firstName) + " " + _vm._s(video.user.lastName)), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(video.user.email))])])])]), _vm._v(" "), _c('div', {
      staticClass: "table--col",
      staticStyle: {
        "max-width": "297px"
      }
    }, [(video.status == 'pending') ? _c('div', {
      staticClass: "table--col-row"
    }, [_c('button', {
      staticClass: "btn btn_green",
      on: {
        "click": function($event) {
          _vm.approve(video, 'approve')
        }
      }
    }, [_vm._v("\n                        Schedule\n                    ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn_red",
      on: {
        "click": function($event) {
          _vm.approve(video, 'reject')
        }
      }
    }, [_vm._v("\n                        Decline\n                    ")])]) : _vm._e(), _vm._v(" "), (video.status == 'processing') ? _c('div', {
      staticClass: "table--col-row"
    }, [_c('span', [_vm._v("Uploading....")])]) : _vm._e(), _vm._v(" "), (video.status == 'approve') ? _c('div', {
      staticClass: "table--col-row"
    }, [_c('button', {
      staticClass: "btn btn_green btn_done"
    }, [_c('svg', {
      attrs: {
        "height": "8",
        "viewbox": "0 0 11 8",
        "width": "11",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M11 1.647L9.25 0l-5 4.706-2.5-2.353L0 4l4.25 4",
        "fill-rule": "nonzero"
      }
    })]), _vm._v("\n                        Scheduled\n                    ")])]) : _vm._e(), _vm._v(" "), (video.status == 'reject') ? _c('div', {
      staticClass: "table--col-row"
    }, [_c('button', {
      staticClass: "btn btn_red btn_done"
    }, [_c('svg', {
      attrs: {
        "height": "8",
        "viewbox": "0 0 11 8",
        "width": "11",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M11 1.647L9.25 0l-5 4.706-2.5-2.353L0 4l4.25 4",
        "fill-rule": "nonzero"
      }
    })]), _vm._v("\n                        Rejected\n                    ")])]) : _vm._e()])])
  })], 2), _vm._v(" "), (_vm.nextPage) ? _c('a', {
    staticClass: "btn btn_green u-fleft",
    on: {
      "click": function($event) {
        _vm.fetchResource()
      }
    }
  }, [_vm._v("\n        Load more\n    ")]) : _vm._e(), _vm._v(" "), _c('loading', {
    attrs: {
      "visible": _vm.loadingVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.loadingVisible = $event
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h1', [_vm._v("\n            Pending\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topBar--item_right"
  }, [_c('a', {
    staticClass: "btn",
    attrs: {
      "href": "/schedule_add.html"
    }
  }, [_vm._v("\n                Schedule new video\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table--col",
    staticStyle: {
      "max-width": "126px"
    }
  }, [_c('div', {
    staticClass: "table--col-title"
  }, [_vm._v("\n                    Video\n                ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-62033c8a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62033c8a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pending/Pending.vue
// module id = 443
// module chunks = 1